import { useParams } from 'react-router-dom';
import useViewRealPlayQuery from 'features/realplays/services/queries/useViewRealplay';
import { useShouldShowAIProspectSection } from 'features/roleplay/RoleplayHooks';

const RealPlayViewLogic = () => {
  const { uuid } = useParams();
  const { isLoading } = useViewRealPlayQuery({ uuid });
  const aiProspectOption = useShouldShowAIProspectSection();

  return { isLoading, aiProspectOption };
};

export default RealPlayViewLogic;
